export default __webpack_public_path__ + "static/media/topIcon.4b214df8.svg";